'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicTooltipSlot = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleCore = require('reactackle-core');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPortal = require('react-portal');

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _TooltipWrapperStyled = require('./styles/TooltipWrapperStyled');

var _common = require('./common');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  /**
   * Determines whether Tooltip is visible
   */
  visible: _propTypes2.default.bool,

  /**
   * @ignore
   */
  positionX: _propTypes2.default.oneOf(["right", "left"]),

  /**
   * @ignore
   */
  positionY: _propTypes2.default.oneOf(["top", "bottom"]),

  /**
   * Function to toggle event listener
   */
  toggleEventListener: _propTypes2.default.func,

  /**
   * Function to toggle event clean event listener
   */
  cleanEventListeners: _propTypes2.default.func
};
var defaultProps = {
  visible: true,
  positionX: 'left',
  positionY: 'bottom',
  toggleEventListener: _reactackleCore.noop,
  cleanEventListeners: _reactackleCore.noop
};

var DynamicTooltipSlot = exports.DynamicTooltipSlot = function (_Component) {
  _inherits(DynamicTooltipSlot, _Component);

  function DynamicTooltipSlot(props) {
    _classCallCheck(this, DynamicTooltipSlot);

    var _this = _possibleConstructorReturn(this, (DynamicTooltipSlot.__proto__ || Object.getPrototypeOf(DynamicTooltipSlot)).call(this, props));

    _this.state = {
      positionX: void 0,
      positionY: void 0,
      top: 0,
      left: 0
    };
    _this._element = null;
    _this._createElementRef = _this._createElementRef.bind(_this);
    _this._setPosition = _this._setPosition.bind(_this);
    return _this;
  }

  _createClass(DynamicTooltipSlot, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var toggleEventListener = this.props.toggleEventListener;
      toggleEventListener({
        target: window,
        event: 'resize',
        cb: this._setPosition
      });
      toggleEventListener({
        target: document,
        event: 'mousemove',
        cb: this._setPosition
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.cleanEventListeners();
    }
  }, {
    key: '_setPosition',
    value: function _setPosition(_ref) {
      var _ref$clientX = _ref.clientX,
          left = _ref$clientX === undefined ? 0 : _ref$clientX,
          _ref$clientY = _ref.clientY,
          top = _ref$clientY === undefined ? 0 : _ref$clientY;
      if (!this._element || !this.props.visible) return;

      var _element$getBoundingC = this._element.getBoundingClientRect(),
          width = _element$getBoundingC.width,
          height = _element$getBoundingC.height;

      var positionX = void 0,
          positionY = void 0;
      if (left + width > document.body.clientWidth) positionX = 'left';else if (left < 0) positionX = 'right';
      if (top + height > document.body.clientHeight) positionY = 'top';else if (top < 0) positionY = 'bottom';
      this.setState({
        left: left + 1,
        top: top + 1,
        positionX: positionX,
        positionY: positionY
      });
    }
  }, {
    key: '_createElementRef',
    value: function _createElementRef(ref) {
      this._element = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          left = _state.left,
          top = _state.top,
          children = this.props.children;
      return _react2.default.createElement(_reactPortal2.default, {
        isOpened: this.props.visible
      }, _react2.default.createElement(_TooltipWrapperStyled.TooltipWrapperStyled, {
        style: {
          left: left,
          top: top
        }
      }, typeof children !== 'function' ? children : children({
        positionX: this.state.positionX || this.props.positionX,
        positionY: this.state.positionY || this.props.positionY,
        tooltipRef: this._createElementRef
      })));
    }
  }]);

  return DynamicTooltipSlot;
}(_react.Component);

DynamicTooltipSlot.propTypes = propTypes;
DynamicTooltipSlot.defaultProps = defaultProps;
exports.default = (0, _common.withEventListeners)(DynamicTooltipSlot);